$(document).on('turbolinks:load', function () {
  if (($('body').hasClass('whatsapp_instances-show') && $('#whatsapp_connected').val() == 'false') || ($('body').hasClass('whatsapp_instances-check_instace_external') && $('#whatsapp_connected').val() == 'false')) {
    setInterval(() => {
      $.ajax({
        url: "/check_whatsapp_instance?whatsapp_instance_id=" + $("#whatsapp_instance_id").val(),
        cache: false
      })
        .done(function (html) {
          console.log(html)
          if (html.status) {
            location.reload();
          }
        });
    }, "30000")
  }
  if ($('body').hasClass('whatsapp_instances')) {
    function check_api_channel() {
      if ($("#whatsapp_instance_api_channel").val() == "cloud_api") {
        $(".oficial").show();
        $("#proxy-tab-item, #calls-tab-item").hide();
      } else {
        $(".oficial").hide();
        $("#proxy-tab-item, #calls-tab-item").show();
      }
      check_coex_required();
    }
    function check_coex_required() {
      const isCoex = $("#whatsapp_instance_is_coex").is(":checked");
      const isCloudApi = $("#whatsapp_instance_api_channel").val() == "cloud_api";
      if (isCoex && isCloudApi) {
        $("#whatsapp_instance_api_number_id").prop('required', true);
        $("#whatsapp_instance_api_business_id").prop('required', true);
        $("#whatsapp_instance_api_token").prop('required', true);
      } else {
        $("#whatsapp_instance_api_number_id").prop('required', false);
        $("#whatsapp_instance_api_business_id").prop('required', false);
        $("#whatsapp_instance_api_token").prop('required', false);
      }
    }
    function toggle_reject_call_message() {
      if ($("#whatsapp_instance_reject_call").is(":checked")) {
        $("#reject_call_message_container").slideDown();
      } else {
        $("#reject_call_message_container").slideUp();
      }
    }
    $("#whatsapp_instance_api_channel").on('change', '', function (e) {
      check_api_channel();
    });
    $("#whatsapp_instance_is_coex").on('change', '', function (e) {
      check_coex_required();
    });
    $("#whatsapp_instance_reject_call").on('change', '', function (e) {
      toggle_reject_call_message();
    });
    check_api_channel();
  }
})

window.confirmResendNumber = function (number, url, instance_id) {
  Swal.fire({
    title: 'Resend',
    input: 'text',
    showCancelButton: true,
    confirmButtonText: 'Resend',
    showLoaderOnConfirm: true,
    inputValue: number
  }).then((result) => {
    console.log(result)
    if (result.isConfirmed) {
      if (url.includes("locale") || url.includes("order")) {
        link = url + '&retry_9=' + instance_id + '&number=' + result.value
      } else {
        link = url + '&retry_9=' + instance_id + '&number=' + result.value
      }
      window.location = link
    }
  })
}

window.confirmResendMeta = function (url, id) {
  Swal.fire({
    title: 'Reenviar mensagem?',
    text: 'Isso vai tentar enviar esta mensagem novamente agora.',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Reenviar'
  }).then((result) => {
    if (result.isConfirmed) {
      var sep = url.indexOf('?') === -1 ? '?' : '&'
      window.location = url + sep + 'retry_meta=' + id
    }
  })
}

window.fbAsyncInit = function () {
  FB.init({
    appId: '844293782109565',
    cookie: true,
    xfbml: true,
    version: 'v24.0'
  });
};

window.launchWhatsAppSignup = function () {
  // Callback para receber a resposta do Embedded Signup
  const sessionInfoListener = function (event) {
    // Verifica se a mensagem vem do Facebook (pode ser facebook.com ou web.facebook.com)
    if (event.origin !== "https://www.facebook.com" && event.origin !== "https://web.facebook.com") return;
    try {
      const data = JSON.parse(event.data);
      if (data.type === 'WA_EMBEDDED_SIGNUP') {
        console.log("WA_EMBEDDED_SIGNUP event:", data.event, data.data);
        // data.data contém: phone_number_id e waba_id
        if (data.event === 'FINISH' && data.data) {
          if (data.data.phone_number_id) {
            $("#whatsapp_instance_api_number_id").val(data.data.phone_number_id);
          }
          if (data.data.waba_id) {
            $("#whatsapp_instance_api_business_id").val(data.data.waba_id);
          }
        } else if (data.event === 'CANCEL') {
          console.log("Signup cancelado na etapa:", data.data?.current_step);
        } else if (data.data) {
          // Fallback para formato antigo sem event field
          if (data.data.phone_number_id) {
            $("#whatsapp_instance_api_number_id").val(data.data.phone_number_id);
          }
          if (data.data.waba_id) {
            $("#whatsapp_instance_api_business_id").val(data.data.waba_id);
          }
        }
      }
    } catch (e) {
      // Mensagem não é JSON, ignorar
    }
  };

  // Fix #1: Remove listener anterior para evitar acúmulo a cada clique no botão
  if (window._wabaSessionInfoListener) {
    window.removeEventListener('message', window._wabaSessionInfoListener);
  }
  window._wabaSessionInfoListener = sessionInfoListener;
  window.addEventListener('message', sessionInfoListener);

  // Fix #4: Desabilitar botão durante o processo para evitar duplo clique
  const signupBtn = document.querySelector('button[onclick="launchWhatsAppSignup()"]');
  if (signupBtn) signupBtn.disabled = true;

  // Fix #2: Resetar flag de submit ao iniciar novo fluxo
  window._wabaSubmitting = false;

  const isCoex = $("#whatsapp_instance_is_coex").is(":checked");
  FB.login(function (response) {
    if (response.authResponse) {
      console.log("Auth response:", response.authResponse);
      const code = response.authResponse.code;
      console.log("Code obtido:", code);
      // Envia o code para o backend trocar pelo token permanente
      document.getElementById('modal_loading').style.display = 'block';
      const currentPhoneId = $("#whatsapp_instance_api_number_id").val() || '';
      const currentWabaId = $("#whatsapp_instance_api_business_id").val() || '';
      fetch(`/waba_phone_id?code=${code}&current_phone_id=${currentPhoneId}&current_waba_id=${currentWabaId}`, {
        method: 'GET',
      })
        .then(res => res.json())
        .then(data => {
          console.log("Resposta do servidor:", data);

          // Fix #3: Verificar status antes de submeter — aborta se o backend retornou erro
          if (!data.status) {
            alert("Erro ao conectar com o WhatsApp: " + (data.error || "Erro desconhecido"));
            document.getElementById('modal_loading').style.display = 'none';
            if (signupBtn) signupBtn.disabled = false;
            return;
          }

          if (data.phone_id) {
            $("#whatsapp_instance_api_number_id").val(data.phone_id);
          }
          if (data.waba) {
            $("#whatsapp_instance_api_business_id").val(data.waba);
          }
          if (data.permant_token) {
            $("#whatsapp_instance_api_token").val(data.permant_token);
          }

          // Fix #2: Flag anti-double-submit — garante que o form só é submetido uma vez
          if (window._wabaSubmitting) {
            console.warn("Submit já em andamento, ignorando chamada duplicada.");
            return;
          }
          window._wabaSubmitting = true;

          document.getElementById('modal_loading').style.display = 'none';
          $('form').first().submit();
        })
        .catch(err => {
          alert("Erro ao conectar com o Whatsapp: " + err);
          document.getElementById('modal_loading').style.display = 'none';
          // Fix #2 + #4: Resetar flag e botão em caso de erro
          window._wabaSubmitting = false;
          if (signupBtn) signupBtn.disabled = false;
        });
    } else {
      console.log('Usuário cancelou ou não autorizou.');
      // Fix #4: Reabilitar botão se o usuário cancelou o login
      if (signupBtn) signupBtn.disabled = false;
    }
  }, {
    config_id: '1287215366298214', // Configuration ID do Facebook Login for Business
    response_type: 'code',
    override_default_response_type: true,
    extras: isCoex ? {
      setup: {},
      featureType: "whatsapp_business_app_onboarding",
      sessionInfoVersion: "3"
    } : {
      setup: {}
    }
  });
};

window.generatePairingCode = function (instanceId, start) {
  Swal.fire({
    title: 'Gerar Código de Pareamento',
    text: 'Digite o número do telefone com DDI (ex: 5511999999999):',
    input: 'text',
    inputPlaceholder: '5511999999999',
    showCancelButton: true,
    confirmButtonText: 'Gerar Código',
    cancelButtonText: 'Cancelar',
    showLoaderOnConfirm: true,
    preConfirm: (phone) => {
      if (!phone) {
        Swal.showValidationMessage('O número de telefone é obrigatório.');
        return false;
      }
      const url = start ? '/pairing_code_external' : `/whatsapp_instances/${instanceId}/pairing_code`;
      const postData = {
        phone: phone,
        authenticity_token: $('meta[name="csrf-token"]').attr('content')
      };
      if (start) {
        postData.whatsapp_instance_id = instanceId;
        postData.start = start;
      }
      return $.ajax({
        url: url,
        type: 'POST',
        data: postData
      }).then(response => {
        if (!response.success) {
          throw new Error(response.error || 'Erro ao gerar o código.');
        }
        return response;
      }).catch(error => {
        Swal.showValidationMessage(error.message || 'Erro de comunicação com o servidor.');
      });
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {
    if (result.isConfirmed && result.value && result.value.success) {
      Swal.fire({
        title: 'Código Gerado!',
        html: `Insira o código abaixo no seu WhatsApp em <b>Aparelhos Conectados > Conectar com número de telefone</b>:<br><br><h2 class="text-primary font-weight-bold" style="letter-spacing: 2px;">${result.value.code}</h2>`,
        icon: 'success',
        confirmButtonText: 'OK'
      });
    }
  });
}
